import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { GlobalService } from '../global.service';

@Component({
  selector: 'app-daily-stack-report-new',
  templateUrl: './daily-stack-report-new.component.html',
  styleUrls: ['./daily-stack-report-new.component.scss']
})
export class DailyStackReportNewComponent implements OnInit {

  sale_date: any = null;
  title: any;
  data_loading = false;
  is_data_available = false;
  document_file = null;
  pdf_data: any = null;

  constructor(private globalService: GlobalService, private httpService: HttpService, private domSanitizer: DomSanitizer,private dom: DomSanitizer) {
    this.title = this.globalService._active_display_name;
  }

  serveDailyStock() {
    let data_dict = {
      'sale_date': this.sale_date
    };
    this.is_data_available = false;
    this.data_loading = true;
    this.httpService.serveDailyStockReportNew(data_dict).subscribe((data) => {
      console.info(data)
      console.log(data);
      // this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/xlsx;base64,' + data['excel']);
      this.document_file = data;
      console.info(this.document_file)
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
    });
  }

  downloadClicked() {
    this.data_loading = false;

    const linkSource = 'data:application/xlsx;base64,' + this.document_file['excel'];
    // let w = window.open(linkSource);
    // w.print();
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  
  }

  changeEvent() {
    this.document_file = null;
  }
  ngOnInit() {
  }

}
